import { queryOptions, useQuery, UseQueryResult } from '@tanstack/react-query'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { ApiPaginationResponseInterface } from 'shared/types/api-pagination-response-interface'
import { UseQueryClearOptions } from 'shared/types/tanstack-utility-types'
import { PostCommentsInfoInterface } from 'modules/community/types/post-info'
import { communityKeys } from './key-factory'

interface UsePostsCommentsInfoOptions extends UseQueryClearOptions<
  ApiPaginationResponseInterface<PostCommentsInfoInterface>,
  Error,
  ApiPaginationResponseInterface<PostCommentsInfoInterface>
> {
  postIds?: number[]
}

export function usePostsCommentsInfo({
  postIds,
  ...options
}: UsePostsCommentsInfoOptions): UseQueryResult<
  ApiPaginationResponseInterface<PostCommentsInfoInterface>,
  Error
> {
  const { fetcher } = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.get,
    ApiPaginationResponseInterface<PostCommentsInfoInterface>
  >({
    method: RequestMethodsEnum.get,
  })

  return useQuery(
    queryOptions({
      queryKey: communityKeys.postsCommentsInfo(postIds ?? []),
      queryFn: async () => {
        const searchQuery = new URLSearchParams()

        for (const id of postIds ?? []) searchQuery.append('post_id[]', `${id}`)

        const response = await fetcher(`/api/comment/post_infos?${searchQuery.toString()}`)

        return response
      },
      enabled: Boolean(postIds?.length),
      ...options,
    }),
  )
}
